"use client";

import Logo from "@/base/component/logo";
import {
  Button,
  Link,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle,
} from "@heroui/react";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function BasicNavbar() {
  const router = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Navbar
      className="static bg-transparent"
      isBlurred={false}
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
    >
      <NavbarContent>
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="sm:hidden"
        />
        <NavbarBrand>
          <Logo />
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent className="hidden sm:flex" justify="center">
        <NavbarItem>
          <Link
            href="/#pricing"
            onPress={() => {
              setIsMenuOpen(false);
            }}
            className="text-sm hover:underline"
          >
            Pricing
          </Link>
        </NavbarItem>

        <NavbarItem>
          <Link href="/features" className="text-sm hover:underline">
            Features
          </Link>
        </NavbarItem>

        <NavbarItem>
          <Link href="/how-it-works" className="text-sm hover:underline">
            How it works
          </Link>
        </NavbarItem>
      </NavbarContent>

      <NavbarMenu className="py-8 !h-min">
        <NavbarMenuItem>
          <Button
            variant="light"
            color="primary"
            onPress={() => {
              setIsMenuOpen(false);
              router.push("/#pricing");
            }}
            className="w-full"
          >
            Pricing
          </Button>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Button
            variant="light"
            color="primary"
            onPress={() => {
              setIsMenuOpen(false);
              router.push("/features");
            }}
            className="w-full"
          >
            Features
          </Button>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Button
            variant="light"
            color="primary"
            onPress={() => {
              setIsMenuOpen(false);
              router.push("/how-it-works");
            }}
            className="w-full"
          >
            How it works
          </Button>
        </NavbarMenuItem>
      </NavbarMenu>
    </Navbar>
  );
}
